import React from "react";
import SwipeableViews from "react-swipeable-views";
import { virtualize } from "react-swipeable-views-utils";
import ArticleCard from "../ArticleCard";

const VirtualizeSwipeableView = virtualize(SwipeableViews);

function mod(n, m) {
  const q = n % m;
  return q < 0 ? q + m : q;
}

export default class SwipeableArticleCard extends React.Component {
  render() {
    const {
      onChangeIndex,
      currentArticleIndex,
      articles,
      isLoggedIn,
      showPrice,
      showUVP
    } = this.props;

    return (
      <VirtualizeSwipeableView
        resistance={true}
        style={{
          height: "100%"
        }}
        index={currentArticleIndex}
        onChangeIndex={onChangeIndex}
        overscanSlideAfter={1}
        overscanSlideBefore={1}
        slideCount={articles.length}
        slideRenderer={params => {
          const { index, key } = params;
          const currentIndex = mod(index, articles.length);

          return (
            <div
              className="h-full w-full flex flex-col items-center justify-center px-3 py-2"
              key={key}
            >
              {Number.isNaN(currentIndex) ? (
                <div>Loading...</div>
              ) : (
                <ArticleCard
                  {...articles[currentIndex]}
                  showPrice={showPrice}
                  showUVP={showUVP}
                  isLoggedIn={isLoggedIn}
                />
              )}
            </div>
          );
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/SwipeableArticleCard/SwipeableArticleCard.js